var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/logo.png")},on:{"click":_vm.scrollToTop}}),_c('div',{staticClass:"text-sm margin-top"},[_vm._v("©2024 IREY PHARMACY")])])
}
var staticRenderFns = []

export { render, staticRenderFns }